"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _downshift = require("downshift");
var _underscore = _interopRequireDefault(require("underscore"));
var _create_async_filter = _interopRequireDefault(require("./utils/create_async_filter"));
var _use_async_dropdown_filter = _interopRequireDefault(require("./use_async_dropdown_filter"));
var _use_row_virtualizer = _interopRequireDefault(require("./use_row_virtualizer"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var stateReducer = function stateReducer(state, actionAndChanges) {
  var _changes$selectedItem, _state$selectedItem;
  var changes = actionAndChanges.changes,
    type = actionAndChanges.type;
  if (changes !== null && changes !== void 0 && (_changes$selectedItem = changes.selectedItem) !== null && _changes$selectedItem !== void 0 && _changes$selectedItem.disabled) {
    return state;
  }
  switch (type) {
    case _downshift.useCombobox.stateChangeTypes.InputKeyDownEscape:
    case _downshift.useCombobox.stateChangeTypes.InputBlur:
      return _objectSpread(_objectSpread({}, state), {}, {
        inputValue: ((_state$selectedItem = state.selectedItem) === null || _state$selectedItem === void 0 ? void 0 : _state$selectedItem.label) || '',
        isOpen: changes.isOpen
      });
  }
  return changes;
};
var useSingleDropdown = function useSingleDropdown(options) {
  var itemsFetcher = _underscore["default"].isFunction(options.items) ? options.items : (0, _create_async_filter["default"])(options.items);
  var _useAsyncDropdownFilt = (0, _use_async_dropdown_filter["default"])(itemsFetcher),
    _useAsyncDropdownFilt2 = (0, _slicedToArray2["default"])(_useAsyncDropdownFilt, 3),
    items = _useAsyncDropdownFilt2[0],
    loadingStatus = _useAsyncDropdownFilt2[1],
    onSearchTermChange = _useAsyncDropdownFilt2[2];
  var itemToString = function itemToString(item) {
    return (item === null || item === void 0 ? void 0 : item.label) || '';
  };
  var defaultOptions = {
    itemToString: itemToString,
    onInputValueChange: function onInputValueChange(e) {
      onSearchTermChange(e.inputValue);
    },
    stateReducer: stateReducer,
    defaultHighlightedIndex: 0
  };
  var overrides = {
    items: items
  };
  var _useRowVirtualizer = (0, _use_row_virtualizer["default"])(items),
    rowVirtualizer = _useRowVirtualizer.rowVirtualizer,
    parentRef = _useRowVirtualizer.parentRef;
  var comboboxOptions = Object.assign({
    onHighlightedIndexChange: function onHighlightedIndexChange(_ref) {
      var highlightedIndex = _ref.highlightedIndex,
        type = _ref.type;
      if (type !== _downshift.useCombobox.stateChangeTypes.MenuMouseLeave) {
        rowVirtualizer.scrollToIndex(highlightedIndex);
      }
    }
  }, defaultOptions, options, overrides);
  return _objectSpread(_objectSpread({}, (0, _downshift.useCombobox)(comboboxOptions)), {}, {
    items: items,
    loadingStatus: loadingStatus,
    loadInitialOptions: function loadInitialOptions() {
      onSearchTermChange('');
    },
    rowVirtualizer: rowVirtualizer,
    parentRef: parentRef
  });
};
var _default = exports["default"] = useSingleDropdown;